'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminUsersController', ['$scope', '$http', '$timeout', function($scope, $http, $timeout) {

  var API = '/api/admin/users';
  var ROLES_ALL = ['ROLE_USER', 'ROLE_EDITOR', 'ROLE_MODERATOR', 'ROLE_ADMIN'];

  $scope.users        = [];
  $scope.isLoading    = true;
  $scope.showModal    = false;
  $scope.saving       = false;
  $scope.currentPage  = 1;
  $scope.itemsPerPage = 10;
  $scope.totalItems   = 0;
  $scope.totalPages   = 0;
  $scope.searchQuery  = '';
  $scope.filterRole   = '';
  $scope.editingUser    = {};
  $scope.allRoles       = ROLES_ALL;
  $scope.successMsg     = '';
  $scope.errorMsg       = '';
  $scope.showResetModal = false;
  $scope.resetUser      = null;
  $scope.resetForm      = { password: '', confirm: '' };
  $scope.resetting      = false;

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  function loadUsers() {
    $scope.isLoading = true;
    var params = { page: $scope.currentPage - 1, size: $scope.itemsPerPage };
    if ($scope.searchQuery) params.search = $scope.searchQuery;
    if ($scope.filterRole)  params.role   = $scope.filterRole;

    $http.get(API, { params: params })
      .then(function(res) {
        var data = res.data;
        if (Array.isArray(data)) {
          $scope.users      = data;
          $scope.totalItems = data.length;
          $scope.totalPages = Math.ceil(data.length / $scope.itemsPerPage) || 1;
        } else {
          $scope.users      = data.content || [];
          $scope.totalItems = data.totalElements || 0;
          $scope.totalPages = data.totalPages || 1;
        }
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des utilisateurs.'); })
      .finally(function() { $scope.isLoading = false; });
  }

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { $scope.currentPage = 1; loadUsers(); }, 350);
  };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p; loadUsers();
  };

  $scope.getPages = function() {
    var pages = [], s = Math.max(1, $scope.currentPage - 2), e = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = s; i <= e; i++) pages.push(i);
    return pages;
  };

  $scope.formatDate = function(date) {
    if (!date) return '—';
    var day, month, year;
    if (Array.isArray(date)) {
      year = date[0]; month = date[1]; day = date[2];
    } else {
      var d = new Date(date);
      if (isNaN(d.getTime())) return '—';
      day = d.getDate(); month = d.getMonth() + 1; year = d.getFullYear();
    }
    return (day < 10 ? '0' + day : '' + day) + '/' +
           (month < 10 ? '0' + month : '' + month) + '/' + year;
  };

  $scope.hasRole = function(user, role) {
    return user && user.authorities && user.authorities.some(function(a) {
      return (a.name || a) === role;
    });
  };

  $scope.getRoleLabel = function(user) {
    if (!user || !user.authorities) return 'Utilisateur';
    var auths = user.authorities.map(function(a) { return a.name || a; });
    if (auths.indexOf('ROLE_ADMIN')     !== -1) return 'Admin';
    if (auths.indexOf('ROLE_MODERATOR') !== -1) return 'Modérateur';
    if (auths.indexOf('ROLE_EDITOR')    !== -1) return 'Éditeur';
    return 'Utilisateur';
  };

  $scope.getRoleBadge = function(user) {
    var label = $scope.getRoleLabel(user);
    if (label === 'Admin')     return 'adm-badge-danger';
    if (label === 'Modérateur') return 'adm-badge-warning';
    if (label === 'Éditeur')   return 'adm-badge-info';
    return 'adm-badge-muted';
  };

  $scope.openModal = function(user) {
    if (user) {
      $scope.editingUser = angular.copy(user);
      var auths = (user.authorities || []).map(function(a) { return a.name || a; });
      if      (auths.indexOf('ROLE_ADMIN')     !== -1) $scope.editingUser.role = 'ROLE_ADMIN';
      else if (auths.indexOf('ROLE_MODERATOR') !== -1) $scope.editingUser.role = 'ROLE_MODERATOR';
      else if (auths.indexOf('ROLE_EDITOR')    !== -1) $scope.editingUser.role = 'ROLE_EDITOR';
      else                                              $scope.editingUser.role = 'ROLE_USER';
    } else {
      $scope.editingUser = { activated: true, role: 'ROLE_USER' };
    }
    $scope.showModal = true;
  };

  $scope.closeModal = function() { $scope.showModal = false; $scope.editingUser = {}; };

  $scope.saveUser = function() {
    if (!$scope.editingUser.login && !$scope.editingUser.email) {
      flash('errorMsg', 'Le login ou email est obligatoire.'); return;
    }
    $scope.saving = true;
    var req = $scope.editingUser.id
      ? $http.put(API + '/' + $scope.editingUser.id, $scope.editingUser)
      : $http.post(API, $scope.editingUser);
    req.then(function() {
      $scope.closeModal(); loadUsers();
      flash('successMsg', $scope.editingUser.id ? 'Utilisateur mis à jour.' : 'Utilisateur créé.');
    })
    .catch(function() { flash('errorMsg', 'Erreur lors de l\'enregistrement.'); })
    .finally(function() { $scope.saving = false; });
  };

  $scope.toggleStatus = function(user) {
    $http.put(API + '/' + user.id + '/activate', { activated: !user.activated })
      .then(function() { loadUsers(); flash('successMsg', 'Statut mis à jour.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors du changement de statut.'); });
  };

  $scope.deleteUser = function(user) {
    if (!confirm('Supprimer l\'utilisateur "' + (user.login || user.email) + '" ? Cette action est irréversible.')) return;
    $http.delete(API + '/' + user.id)
      .then(function() { loadUsers(); flash('successMsg', 'Utilisateur supprimé.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  $scope.openResetModal = function(user) {
    $scope.resetUser         = user;
    $scope.resetForm         = { password: '', confirm: '' };
    $scope.showResetModal    = true;
  };

  $scope.closeResetModal = function() {
    $scope.showResetModal = false;
    $scope.resetUser      = null;
    $scope.resetForm      = { password: '', confirm: '' };
  };

  $scope.submitResetPassword = function() {
    var pwd = $scope.resetForm.password;
    var cfm = $scope.resetForm.confirm;
    if (!pwd || pwd.length < 6) {
      flash('errorMsg', 'Le mot de passe doit contenir au moins 6 caractères.'); return;
    }
    if (pwd !== cfm) {
      flash('errorMsg', 'Les mots de passe ne correspondent pas.'); return;
    }
    $scope.resetting = true;
    var targetUser = $scope.resetUser;
    $http.put(API + '/' + targetUser.id + '/reset-password', { newPassword: pwd })
      .then(function() {
        $scope.closeResetModal();
        flash('successMsg', 'Mot de passe de "' + (targetUser.login || targetUser.email) + '" réinitialisé.');
      })
      .catch(function() { flash('errorMsg', 'Erreur lors de la réinitialisation.'); })
      .finally(function() { $scope.resetting = false; });
  };

  loadUsers();
}]);
